import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Tag } from 'primereact/tag'
import { Chip } from 'primereact/chip'
import { mockProjects, mockClients, mockContracts } from '../../../mocks'
import { projectStatusLabel, projectStatusSeverity } from '../utils/projectHelpers'
import { contractStatusLabel, contractStatusSeverity } from '../../Contracts/utils/contractHelpers'

const ProjectDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const project = mockProjects.find((p) => p.id === id)
  if (!project) {
    return (
      <div>
        <Button icon='pi pi-arrow-left' text label='Voltar' onClick={() => navigate(-1)} />
        <p>Aplicativo não encontrado.</p>
      </div>
    )
  }

  const client = mockClients.find((c) => c.id === project.clientId)
  const contracts = mockContracts.filter((c) => c.projectIds.includes(id!))

  return (
    <div style={{ maxWidth: 900 }}>
      <Button
        icon='pi pi-arrow-left'
        text
        label='Voltar para Aplicativos'
        onClick={() => navigate('/dashboard/aplicativos')}
        style={{ marginBottom: '1.5rem' }}
      />

      {/* Header */}
      <Card style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
              <h2 style={{ margin: 0 }}>{project.name}</h2>
              <Tag value={projectStatusLabel(project.status)} severity={projectStatusSeverity(project.status)} />
            </div>
            <p style={{ color: 'var(--text-color-secondary)', margin: '0 0 1rem' }}>{project.description}</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {client && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <i className='pi pi-building' style={{ color: 'var(--text-color-secondary)', width: 18 }} />
                  <span
                    style={{ cursor: 'pointer', color: 'var(--primary-color)' }}
                    onClick={() => navigate(`/dashboard/clientes/${client.id}`)}
                  >
                    {client.name}
                  </span>
                </div>
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <i className='pi pi-github' style={{ color: 'var(--text-color-secondary)', width: 18 }} />
                <a href={project.repositoryUrl} target='_blank' rel='noreferrer' style={{ color: 'var(--primary-color)' }}>
                  {project.repositoryUrl}
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <i className='pi pi-cloud' style={{ color: 'var(--text-color-secondary)', width: 18 }} />
                <span>{project.hosting}</span>
                {project.hostingUrl && (
                  <>
                    <span style={{ color: 'var(--text-color-secondary)' }}>·</span>
                    <a href={project.hostingUrl} target='_blank' rel='noreferrer' style={{ color: 'var(--primary-color)' }}>
                      {project.hostingUrl}
                    </a>
                  </>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <i className='pi pi-calendar' style={{ color: 'var(--text-color-secondary)', width: 18 }} />
                <span>Criado em {new Date(project.createdAt).toLocaleDateString('pt-BR')}</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '1.5rem' }}>
          <div style={{ fontSize: '0.85rem', color: 'var(--text-color-secondary)', marginBottom: '0.5rem' }}>Stack Tecnológica</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {project.techStack.map((t) => (
              <Chip key={t} label={t} />
            ))}
          </div>
        </div>
      </Card>

      {/* Contracts */}
      <Card title='Contratos Relacionados'>
        {contracts.length === 0 ? (
          <p style={{ color: 'var(--text-color-secondary)' }}>Nenhum contrato vinculado.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {contracts.map((c) => (
              <div
                key={c.id}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: 8, background: 'var(--surface-ground)', cursor: 'pointer' }}
                onClick={() => navigate(`/dashboard/contratos/${c.id}`)}
              >
                <div>
                  <div style={{ fontWeight: 600 }}>{c.title}</div>
                  <div style={{ fontSize: '0.82rem', color: 'var(--text-color-secondary)' }}>
                    {new Date(c.startDate).toLocaleDateString('pt-BR')} até {new Date(c.endDate).toLocaleDateString('pt-BR')}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <span style={{ fontWeight: 600 }}>R$ {c.monthlyFee.toLocaleString('pt-BR')}/mês</span>
                  <Tag value={contractStatusLabel(c.status)} severity={contractStatusSeverity(c.status)} />
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  )
}

export default ProjectDetailPage
